import {paramCase} from 'change-case'

window.__TEST__ = true
window.appName = process.env.REACT_APP_APP_NAME || '20-80 Admin'
window.programmaticAppName = paramCase(window.appName)
